export default "__VITE_ASSET__50592990__"